<template>
    <section class="container hidden">
        <div class="technology-section">
            <!-- EMS Airflow Section -->
            <div class="row-custom">
                <div class="team-col">
                    <h1>EMS Airflow Technologie</h1>
                    <p>
                        Bij Tandzorg Gestel gebruiken we de geavanceerde <strong>EMS Airflow technologie</strong> voor 
                        professionele tandreininging. Deze innovatieve methode combineert water, lucht en speciaal poeder 
                        voor een zachte maar zeer effectieve reiniging van uw tanden en tandvlees.
                    </p>
                    <p>
                        <strong>Voordelen van EMS Airflow:</strong><br>
                        • Veel comfortabeler dan traditionele reiniging<br>
                        • Effectieve verwijdering van plaque en aanslag<br>
                        • Zachter voor tandvlees en tandglazuur<br>
                        • Ideaal voor gevoelige tanden
                    </p>
                </div>
                <div class="team-col image-col-right">
                    <img src="../assets/images/ems.jpg" alt="EMS Airflow technologie voor comfortabele professionele tandreininging" class="tech-image">
                </div>
            </div>

            <!-- Digital Scanner Section -->
            <div class="row-custom reverse">
                <div class="team-col">
                    <h1>Digitale Scanner - Afdrukken zijn Verleden Tijd</h1>
                    <p>
                        Dankzij onze moderne <strong>digitale scanner</strong> maken we vrijwel geen traditionele afdrukken meer. 
                        Deze geavanceerde technologie scant uw gebit in 3D binnen enkele minuten, zonder het oncomfort van 
                        afdrukmateriaal in uw mond.
                    </p>
                    <p>
                        <strong>Waarom digitaal scannen beter is:</strong><br>
                        • Geen oncomfortabele afdrukpasta meer nodig<br>
                        • Uiterst nauwkeurige 3D-beelden<br>
                        • Sneller en comfortabeler<br>
                        • Direct resultaat zichtbaar op scherm<br>
                        • Perfecte pasvorm voor kronen en bruggen
                    </p>
                </div>
                <div class="team-col image-col-left">
                    <img src="../assets/images/scanner.jpg" alt="Digitale scanner - geen traditionele afdrukken meer nodig" class="tech-image">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "ModerneTechnologie",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if(entry.isIntersecting){
                    entry.target.classList.add('show')
                } 
            })
        })

        const hiddenElements = document.querySelectorAll('.hidden')
        hiddenElements.forEach((el) => observer.observe(el))
    }
}
</script>

<style scoped>
.hidden {
    opacity: 0;
    transform: translateY(100px);
    transition: all 1.5s;
}

.show {
    opacity: 1;
    transform: translateY(0);
}

.technology-section {
    padding: 4rem 0;
}

.team-col {
    flex-basis: 48%;
}

.row-custom {
    margin-bottom: 6rem;
    display: flex;
    align-items: center;
}

.row-custom:last-child {
    margin-bottom: 0;
}

.row-custom.reverse {
    flex-direction: row-reverse;
}

.row-custom .image-col-right, .row-custom .image-col-left {
    display: flex;
    justify-content: center;
}

.tech-image {
    width: 100%;
    max-width: 600px;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.tech-image:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 30px rgba(0,0,0,0.2);
}

.team-col h1 {
    color: var(--blue);
    margin-bottom: 2rem;
    font-size: 2.8rem;
}

.team-col p {
    padding: 0 0 1.5rem 0;
    font-size: 1.4rem;
    line-height: 1.6;
}

.team-col p strong {
    color: var(--blue);
    display: block;
    margin-bottom: 1rem;
    font-size: 1.5rem;
}

#modern-technology-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.15);
}

@media(max-width: 991px) {
    .row-custom {
        margin-bottom: 4rem;
        flex-direction: column !important;
        text-align: center;
    }
    
    .row-custom.reverse {
        flex-direction: column !important;
    }
    
    .team-col {
        margin-bottom: 2rem;
    }
    
    .team-col h1 {
        font-size: 2.2rem;
        text-align: center;
    }

    .tech-image {
        height: 200px !important;
        max-width: 400px;
    }

    .team-col p {
        padding: 0 0 1rem 0;
        text-align: left;
    }
}
</style>
